import { makeStyles } from '@material-ui/core/styles';
import { iconRadioOn, iconRadio } from 'assets/icons/importIcon'

const useStyles = makeStyles((theme: any) => {
  return {
    contentTitle: {
      textAlign: 'center',
      marginBottom: '20px',
      font: `700 19px/25px "Montserrat"`,
      color: theme.custom.colors.primary,
    },
    iconCloseIcon: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginBottom: '20px',
      marginRight: '30px',
      marginTop: '30px',
      cursor: 'pointer'
    },
    contentContainer: {
      display: 'flex',
      paddingLeft: "20px",
      paddingRight: "20px",
      justifyContent: 'center',
      margin: '0 auto',
      '&>div:not(:last-child)': {
        marginRight: 40,
      }
    },
    inputName: {
      marginBottom: 28,
      '&>div:first-child>label': {
        font: 'normal normal 400 16px/16px Montserrat',
        color: theme.custom.colors.primary,
        marginBottom: 4,
        '&:first-letter': {
          textTransform: 'uppercase'
        }
      }
    },
    customTextArea: {
      '&>label': {
        font: 'normal normal 400 16px/16px Montserrat',
        color: theme.custom.colors.primary,
        marginBottom: 4,
        '&:first-letter': {
          textTransform: 'uppercase'
        }
      }
    },
    customUploadImage: {
      '& div:first-child>label': {
        font: 'normal normal 400 16px/16px Montserrat',
        color: theme.custom.colors.primary,
      },
      '& div:nth-child(2)': {
        marginTop: 8,
        marginBottom: 28,
        width: 181,
        height: 124,
        '& label': {
          font: 'normal normal 400 14px/18px Montserrat',
          color: theme.custom.colors.placeholder,
          width: 125,
          textAlign: 'center'
        },
        '& img': {
          width: '100%',
          height: '100%'
        }
      }
    },
    containerInputPrice: {
      display: 'flex',
      flexDirection: 'column',
    },
    textLabelInputPrice: {
      font: 'normal normal 400 16px/16px Montserrat',
      color: theme.custom.colors.primary,
      marginRight: 9,
    },
    textLabelInputPriceDisabled: {
      font: 'normal normal 400 16px/16px Montserrat',
      color: theme.custom.colors.primary,
      marginRight: 9,
    },
    textLabelDescPrice: {
      font: 'normal normal 400 14px/18px Montserrat',
      color: theme.custom.colors.midBlack,
      marginRight: 9,
    },
    contentInputPrice: {
      width: '100%',
      position: 'relative',
      alignItems: 'center',
      display: 'flex',
    },
    inputPrice: {
      width: '186px',
      border: `1px solid ${theme.custom.colors.primary}`,
      height: '32px',
      borderRadius: '20px',
      padding: '0px 16px',
      font: theme.custom.font.placeholder,
      '&::placeholder': {
        font: theme.custom.font.placeholder,
        color: theme.custom.colors.placeholder,
      },
      '&:focus': {
        outline: 'none',
      },
      "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
        "-webkit-appearance": "none",
        display: "none"
      }
    },
    priceSymbol: {
      position: 'absolute',
      font: theme.custom.font.priceSymbol,
      left: '8px',
      marginTop: '-2px',
      color: '#D2D2D2',
    },
    tooltip: {
      background: '#000',
      padding: `10px !important`,
      font: 'normal normal 400 13px/24px Public-Sans !important',
      borderRadius: 20,
      maxWidth: 500,
    },
    popupTooltip: {
      color: '#111',
    },
    rowCheckBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: 12,
      '&>span:first-child': {
        padding: '0 5px 0 0',
      }
    },
    customInputPrice: {
      marginBottom: 22,
      '&>div:first-child': {
        marginBottom: 4,
        '&>label': {
          font: 'normal normal 400 16px/16px Montserrat',
          color: theme.custom.colors.primary,
        }
      }
    },
    typeLength: {
      marginBottom: 28,
      '&>div:first-child': {
        marginBottom: 4
      },
      '&>div:first-child>label': {
        font: 'normal normal 400 16px/16px Montserrat',
        color: theme.custom.colors.primary,
      }
    },
    labelPayment: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: 4,
    },
    radio: {
      background: `url(${iconRadio}) center /100% 100% no-repeat`,
      width: '20px',
      height: '20px',
      lineHeight: '20px',
      // transition: 'background 0.4s'
    },
    radioOn: {
      background: `url(${iconRadioOn}) center /100% 100% no-repeat`,
      width: '20px',
      height: '20px',
      lineHeight: '20px',
      // transition: 'background 0.4s'
    },
    containerErr: {
      '& label': {
        color: `${theme.custom.colors.error1} !important`,
      },
      '& span': {
        color: `${theme.custom.colors.error1} !important`,
      },
      '& input': {
        border: `1px solid ${theme.custom.colors.error1} !important`,
        color: `${theme.custom.colors.error1} !important`,
      }
    },
    errInputPrice: {

    },
    disableInputPrice: {
      '& span': {
        color: `${theme.custom.colors.borderGrey} !important`,
      },
      '& input': {
        border: `1px solid ${theme.custom.colors.borderGrey} !important`,
        color: `${theme.custom.colors.borderGrey} !important`,
      },
    },
    disable: {
      '&>div:nth-child(2) label': {
        color: `${theme.custom.colors.borderGrey} !important`,
      },
      '& fieldset': {
        border: `1px solid ${theme.custom.colors.borderGrey} !important`
      }
    },
    bodyModalList: { 
      marginLeft: 30
    },
    btnAddRecipeBody: {
      marginTop: "20px",
      '& button': {
        height: 32,
        background: theme.custom.colors.purple,
        fontWeight: 'bold',
        color: theme.custom.colors.white,
        fontSize: theme.custom.fontSize.size16,
        fontFamily: theme.custom.fontFamily.title,
        boxShadow: 'none',
        textTransform: 'inherit',
        borderRadius: '30px',
        '& img': {
          marginLeft: 8,
        },
        '&:hover': {
          background: theme.custom.colors.purple,
        },
      },
    },
    footerModal: {
      padding: '0px 55px 25px',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      font: 'normal normal 500 16px/24px Public-Sans',
    },
    buttonBack: {
      '& button': {
        height: 32,
        background: theme.custom.colors.borderGrey,
        fontWeight: 'bold',
        font: theme.custom.font.montserrat16Bold,
        boxShadow: 'none',
        textTransform: 'inherit',
        borderRadius: '30px',
        color: '#333333',
        marginRight: 15,
        marginTop: 24,
        '&:hover': {
          background: theme.custom.colors.borderGrey,
        },
      },
    },
    iconLoading: {
      marginLeft: '15px',
      '& svg': {
        color: '#fff',
      },
    },
    setFreeCheckBox: {
      marginTop: "-10px",
      marginBottom: "-10px"
    },
    paymentCheckbox: {
      marginTop: "-5px",
      marginBottom: "-5px"
    },
    pricingLblContainer: {
      display: "flex",
      flexDirection: "row",
      alignItems: 'center',
      marginBottom: "5px",
    },
    pricingLbl: {
      marginRight: "10px",
      font: theme.custom.font.montserrat16
    },
    pricingLblContainerMarginTop: {
      marginTop: "40px"
    }
  };
});

export default useStyles;
